import styled from 'styled-components';

export const LiveCasinoGridItemBetIntervalMinWrapperBox = styled.span`
    padding-inline-end: 4px;
`;
